import editionModule from "./editionModule"
import nlgEditionHeaderView from "./nlgEditionHeaderView.html"

editionModule.directive("nlgEditionHeader", [()=>{
    return {
        restrict: "E",
        template: nlgEditionHeaderView
    }
}])